import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { EmergencyMechanisation, Mechanisations } from 'src/app/web-api-client';

@Component({
  selector: 'app-emergency-mechanisations-form-select',
  templateUrl: './emergency-mechanisations-form-select.component.html',
  styleUrl: './emergency-mechanisations-form-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmergencyMechanisationsFormSelectComponent {
  @Input() set availableMechanisationsList(value: Mechanisations[]) {
    this._availableMechanisationsList = value.slice();
  }

  @Input() set usedEmergencyMechanisationsList(value: EmergencyMechanisation[]) {
    this._usedEmergencyMechanisationsList = value.slice();
  }

  @Output() emergencyMechanisationAdded = new EventEmitter<EmergencyMechanisation>();
  @Output() emergencyMechanisationDeleted = new EventEmitter<EmergencyMechanisation>();
  @Output() emergencyMechanisationsUpdated = new EventEmitter<EmergencyMechanisation[]>();

  public _usedEmergencyMechanisationsList: EmergencyMechanisation[] = [];
  public _availableMechanisationsList: Mechanisations[] = [];

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef
  ) { }

  public onAddMechanisationClicked(mechanisationID: number) {
    const mechanisation = this._availableMechanisationsList.find(m => m.id === mechanisationID);
    if(mechanisation) {
      const emergencyMechanisation = new EmergencyMechanisation();
      emergencyMechanisation.mechanisation = mechanisation;
      emergencyMechanisation.mechanisationId = mechanisation.id;
      emergencyMechanisation.quantityUsed = 0;

      this._usedEmergencyMechanisationsList.push(emergencyMechanisation);
      this.emergencyMechanisationAdded.emit(emergencyMechanisation);
      this.emergencyMechanisationsUpdated.emit(this._usedEmergencyMechanisationsList);

      const index = this._availableMechanisationsList.findIndex(m => m.id === mechanisationID);
      if(index > -1) {
        this._availableMechanisationsList.splice(index, 1);
        this._availableMechanisationsList = this._availableMechanisationsList.slice();
      }

      this.changeDetectorRef.detectChanges();
    }
  }

  public onDeleteEmergencyMechanisationClicked(emergencyMechanisation: EmergencyMechanisation, event: MouseEvent) {

    event.preventDefault();
    event.stopPropagation();

    const index = this._usedEmergencyMechanisationsList.findIndex(e => e.id === emergencyMechanisation.id);
    if(index > -1) {
      this._usedEmergencyMechanisationsList.splice(index, 1);
      this._usedEmergencyMechanisationsList = this._usedEmergencyMechanisationsList.slice();
      this._availableMechanisationsList.push(emergencyMechanisation.mechanisation);
      this.emergencyMechanisationDeleted.emit(emergencyMechanisation);
      this.emergencyMechanisationsUpdated.emit(this._usedEmergencyMechanisationsList);
    }
  }
}
